export default __webpack_public_path__ + "static/media/78_photo.d056c571.jpg";